<div class="m" *ngIf="candidateKind != 'ETIS-CANDIDATE' && viewContent && getHTMLData">
    <button type="button" class="btn btn-primary ml-1 mr-3 shadow-none no-print" (click)="noFaultPopup()">{{'Complete'|translate}}</button>
    <!-- <button type="button" style="margin-right: 2.4%;" class="reportAProblem pull-right" (click)="reportAProblemPopup()">{{'Report A Problem'|translate}} </button> -->
</div>
<div class="container" *ngIf="viewContent && getHTMLData && showHtmlContainer">
    <div class="fdrs-view-card">
        <div class="card-body">
            <div class="fdrs-view-card1">
                <div class="card-body">
                    <div class="fdrs-view-tab-header">
                        <label class="tab-header-label"></label>
                    </div>
                    <div *ngIf="newcontent" class="fdrs-view-content" [innerHTML]="displayHTML | pinpointPipe"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="nospa-content" *ngIf="viewContent && !getHTMLData">
    <button type="button" class="btn btn-primary mr-3 shadow-none no-print nospa-closebtn" (click)="noFaultPopup()">{{'Close'|translate}}
    </button>
    <div class="nospa-header">{{'Information Not Available'|translate}}</div>
    <div class="nospa-title">{{'The information you have requested is not available at this time'|translate}}.</div>
</div>
<div id="overlay" *ngIf="viewCompleteRepairPostPepair">
    <span id="nav-spinner">
      <img src="assets/images/ajax-loader.gif" width="80" height="80">
    </span>
</div>
<ngx-spinner [fullScreen]="false" bdColor="rgba(0, 0, 0, 0)" style="margin-top: 5%;" color="#003478" size="medium"
  type="ball-spin-clockwise">
  <p style="font-size: 20px; font-family: Verdana,Arial,Helvetica,Trebuchet,_sans; color: black;"></p>
</ngx-spinner>